<template>
    <modal  v-model="fade"  class-name="vertical-center-modal" width="400" :mask-closable="maskClosable" @on-visible-change="changeModal">
        <div slot="header" >
            <div class="register-header">{{title}}</div>
        </div>
        <div slot="close">
            <div class="close" @click="hide">x</div>
        </div>
        <Form class="form-group" ref="formData" :model="formData"  :rules="ruleValidate">
            <FormItem  prop="phone">
                <Input type="tel"  size="large" v-model.trim="formData.phone" :placeholder="placeholderInfo.phone">
                    <Icon type="ios-phone-portrait" color="#2d8cf0" slot="prefix" />
                </Input>
            </FormItem>
            <FormItem  prop="verifyCode">
                <Input type="number" style="width: 63%"  size="large" v-model.trim="formData.verifyCode" :placeholder="placeholderInfo.verifyCode">
                    <Icon type="ios-search" color="#2d8cf0" slot="prefix" />
                </Input>
                <Button @click="getCode" class="btn-get-code" size="large" :disabled="getCodeIng" type="primary" ghost>{{getCodeMsg}}</Button>
            </FormItem>
            <FormItem  prop="pwd">
                <Input type="password" ref="pwdInput"  size="large" v-model.trim="formData.pwd" :placeholder="placeholderInfo.pwd">
                    <Icon type="ios-lock-outline" color="#2d8cf0" slot="prefix" />
                </Input>
            </FormItem>
            <FormItem  >
                <Input type="password"  size="large" v-model.trim="enteredPwd" :placeholder="placeholderInfo.enteredPwd">
                    <Icon type="ios-lock-outline" color="#2d8cf0" slot="prefix" />
                </Input>
            </FormItem>
            <FormItem class="form-footer">
                <Button type="primary" long size="large" :loading="isLoading" @click="handleSubmit('formData')">
                    <span v-if="!isLoading" style="font-size: 16px">重置密码</span>
                    <span v-else>Loading。。。</span>
                </Button>
            </FormItem>
            <div class="to-Login"><a href="#" @click="toLogin">去登录</a></div>
        </Form>
        <div slot="footer"></div>
    </modal>
</template>

<script>
    import api from '../../api/api'
    export default {
        props:{
            title:{
                type:String,
                default:'重置密码'
            },
            placeholderInfo:{
                type:Object,
                default(){
                    return {
                        enteredPwd: '请再次输入密码',
                        pwd: '请输入密码',
                        verifyCode: '请输入短信验证码',
                        phone:'请输入手机号'
                    };
                }
            },
            maskClosable:{
                type:Boolean,
                default:true
            }
        },
        data:()=>{
            return{
                fade:false,
                isLoading:false,
                getCodeIng:false,
                getCodeMsg:'获取验证码',
                enteredPwd:'',
                formData:{
                    pwd:'',
                    phone:'',
                    verifyCode:''
                },
                ruleValidate: {
                    pwd: [
                        { required: true, message: '密码不能为空', trigger: 'blur' },
                        { type: 'string', min: 6, max: 16, message: '密码长度6-16个字符', trigger: 'blur' }
                    ],
                    phone: [
                        { required: true, message: '手机号码不能为空', trigger: 'blur' },
                        { type: 'string', min: 11, max: 11, message: '手机号码长度错误', trigger: 'blur' }
                    ],
                    verifyCode: [
                        { required: true, message: '验证码不能为空', trigger: 'blur' },
                        { type: 'string', message: '密码长度6-16个字符', trigger: 'blur' }
                    ]
                }
            }
        },
        computed: {
        },
        methods:{
            countDown : function (btnMsg,seconder) {
                if(!btnMsg){
                    return
                }
                if(this.getCodeIng)return
                var that = this;
                var seconder = seconder||30;
                var seconderText = ''
                this[btnMsg]='剩余('+seconder+')秒'
                if(timer){
                    clearInterval(timer);
                }
                this.getCodeIng = true;
                var timer = setInterval(function () {
                    if(seconder>0){
                        seconder--;
                        seconderText = seconder
                        if(seconderText<10){
                            seconderText = '0'+seconderText
                        }
                        that[btnMsg]='剩余('+seconderText+')秒'
                    }else{
                        clearInterval(timer);
                        that.getCodeIng = false;
                        that[btnMsg] ="获取验证码";
                    }
                },1000)
            },
            _initModalData(){
                this.enteredPwd='';
                this.formData={
                    pwd:'',
                    phone:'',
                    verifyCode:''
                }
            },
            hide() {
                this._initModalData()
                this.fade = false
            },
            open() {
                this.fade = true;
            },
            changeModal(data){
                if(!data){
                    this.hide()
                }
            },
            toLogin(){
                this._initModalData()
                this.$emit('toLogin')
            },
            checkPwd(){
                if(this.enteredPwd != this.formData.pwd){
                    this.$Message.error(`两次输入的密码不一致请重新输入！`)
                    this.$refs.pwdInput.focus()
                    return false
                }else{
                    return true
                }
            },
            handleSubmit (name) {
                var self = this;
                if(!this.checkPwd()){
                    return
                }
                this.isLoading = true;
                this.$refs[name].validate((valid) => {
                    var data = this.$refs[name].model
                    console.log('密码重置：--',data)
                    if(valid){
                        api.resetPwd(data).then(res=>{
                            self.isLoading = false;
                            self.$Message.success('密码重置成功')
                            console.log('密码重置：--',res)
                            self.hide()
                        }).catch(error =>{
                            self.isLoading = false;
                            self.$Message.error(error.info)
                        })
                    }else{
                        self.isLoading = false;
                        this.$Message.error('表单验证失败!')
                    }
                })
            },
            getCode(){
                console.log('getCode')
                var self = this;
                var phone = this.formData.phone;
                if(!phone){
                    this.$Message.error('请输入手机号码!')
                    return
                }
                if(this.getCodeIng)return
                console.log('getCodeIng:',this.getCodeIng)
                this.countDown('getCodeMsg',30)
                api.getResetPwdCode(phone).then(res =>{
                    // alert(JSON.stringify(res))
                }).catch(error =>{
                    self.$Message.error(error.info)
                })

            }
        }
    }
</script>

<style scoped lang="scss">
    .register-header{
        font-size: 18px;
        text-align: left;
        letter-spacing: 3px;
        color: #333;
        font-weight: 600;
    }
    .close{
        width: 18px;
        height: 18px;
        color: #fff;
        font-size: 14px;
        margin-top: 5px;
        text-align: center;
        line-height: 18px;
        background: #ccc;
        border-radius: 15px
    }
    .form-group{
        width: 90%;
        margin: 0 auto;
        .form-item{
            padding-top: 20px;
        }
    }
    .btn-get-code{
        margin-left: 20px;
    }
    .ivu-input-prefix i{
        color: #2d8cf0;
    }
    .forget-pwd{
        text-align: right;
        padding-bottom: 10px;
        font-size: 14px;
    }
    .to-Login{
        text-align: left;
    }
</style>